import { Component, Inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PaginationInstance } from 'ngx-pagination';
import { GlobalService } from 'src/app/services/global/global.service';
import { Filter } from '../../filter/filter.model';
import { JobService } from 'src/app/services/job/job.service';
import { CommonService } from 'src/app/services/common/common.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';

@Component({
  selector: 'app-view-past-history',
  templateUrl: './view-past-history.component.html',
  styleUrls: ['./view-past-history.component.scss']
})
export class ViewPastHistoryComponent {
  public userInfo={
    profile_picture:"",
    first_name:"Vishva",
    last_name:"Cipherhex",
    email:"vishava@cipherhex.com",

  }

  public displayedColumns: string[] = ['company_name','date','time','category','location','total_hour','wages'];

  public dataSource = new MatTableDataSource();
  public count!: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  public isFilterShow: boolean = false;
  pageIndex = 0;
  pageSize = 15;
  public isSpinnerLoading: boolean = false;
  
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public filterArr: any[] = [
    { key_name: "Category", key_val: "d_i", type: 'select' },
  ]
  public searchInput: string = '';
  private previousInputValue: string = '';
  
  constructor(private jobService:JobService,private commonService:CommonService, @Inject(MAT_DIALOG_DATA) public dialogData: any,
  private dialogRef: MatDialogRef<ViewPastHistoryComponent>,private appService:AppService){}
  ngOnInit(): void {
    this.list()
  }
  onCancel(){}

  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    // this.noticesList()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    // this.noticesList()
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
    if (!this.isFilterShow && this.filterObj.arr.length > 0) {
      this.filterObj.arr = [];
      this.list();
    }
  }
  callApi(obj) {
    this.filterObj = obj
    this.list()
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage=0
      this.list()
    }
  }
  onGo(){
    if(this.searchInput.trim()!=''){
      this.config.currentPage=0
      this.list()
    }
  }

  list(){
    let data={
      em_i:this.dialogData.em_i,
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    this.jobService.getPastJobEmp(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          this.dataSource = new MatTableDataSource(success.msg)
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.count =12
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
}
